<template>
  <div :class="{ 'wg-tabs': true, hindLine: $props.hideLine }">
    <div :class="{ 'wg-tabs-box': true }" ref="refWgTabs">
      <div
        v-for="tab in tabList"
        :key="tab.index"
        :class="{
          'wg-tab-item': 1,
          active: tabActive === tab.index,
        }"
        @click="methodChangeTab($event, tab.index)"
      >
        {{ tab.label }}
      </div>
      <div
        v-if="!$props.hideLine"
        class="wg-tab-line"
        :style="{
          width: tabLineWidth + 'px',
          transform: `translateX(${tabLineLeft}px)`,
        }"
      ></div>
    </div>
    <div class="wg-slot">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'component-wg-tabs',
  props: {
    /**
     * 传参格式：
     * {
     *    active:number|string
     *    list:[
     *      { label: number | string, index: number | string },
     *    ]
     * }
     */
    tabData: {
      type: Object,
      default: () => ({
        active: null,
        list: [],
      }),
    },
    hideLine: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tabList: [
      //   { label: '奖励', index: 1 },
      //   { label: '消耗', index: 2 },
    ],
    tabActive: 1,
    tabLineWidth: 0,
    tabLineLeft: 0,
  }),
  created() {
    this.tabList = this.tabData.list.filter((item) => !item.hide)
    this.tabActive = this.tabData.active
  },
  mounted() {
    if (!this.hideLine) {
      const firstActive = this.tabList.findIndex(
        (item) => item.index === this.tabActive
      )
      console.log(firstActive)
      const firstTabItem = this.$refs.refWgTabs.children[
        firstActive < 0 ? 0 : firstActive
      ]
      this.getTabLineStyle(firstTabItem)
    }
  },
  methods: {
    methodChangeTab($e, tab) {
      const target = $e.target
      if (!this.hideLine) {
        this.getTabLineStyle(target)
      }
      this.tabActive = tab
      this.$emit('tabChange', this.tabActive)
    },
    getTabLineStyle(target) {
      const targetRect = target.getBoundingClientRect()
      const parentRect = target.parentNode.getBoundingClientRect()
      this.tabLineWidth = targetRect.width
      this.tabLineLeft = targetRect.left - parentRect.left
    },
  },
}
</script>
<style scoped lang="scss">
.wg-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 2px solid #f6f6f6;
  .wg-tabs-box {
    position: relative;
    .wg-tab-item {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      margin-right: 40px;
      font-size: 14px;
      font-weight: 500;
      color: #303133;
      cursor: pointer;
      transition: color 0.25s, font 0.25s;
      &.active {
        color: #1678ff;
        font-weight: 500;
      }
    }

    .wg-tab-line {
      position: absolute;
      left: 0;
      height: 2px;
      background-color: #1678ff;
      z-index: 1;
      transition: width 0.25s,
        transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }
  &.hindLine {
    height: 40px;
    border: none;
    .wg-tabs-box {
      .wg-tab-item {
        position: relative;
        color: #d3d3d3;
        font-weight: 400;
        font-size: 20px;
        &::after {
          position: absolute;
          left: 50%;
          bottom: -1px;
          transform: translateX(-50%);
          content: '';
          width: 0px;
          height: 5px;
          background: #1778ff;
          border-radius: 5px;
          transition: width 0.25s;
        }
        &.active {
          font-size: 24px;
          color: #333333;
          &::after {
            width: 20px;
          }
        }
      }
    }
  }
}
</style>
